import React from 'react';
import InitiatorCanEditSetting from './components/initiator-can-edit-setting';
import AddToCopyGroupSetting, { ADD_TO_COPY_GROUP_SETTING_KEY } from './components/add-to-copy-group-setting';

export const TextElementSettings = function FromElement({ element, duplicateElement, handlerChangeOption }) {
  return (
    <div className="tabs-item">
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Margin Top (px)</h3>
        <div className="form-control-item">
          <input
            type="number"
            className="form-control"
            placeholder=""
            min={0}
            value={element.options?.marginTop ?? 24}
            onChange={(e) => {
              handlerChangeOption(e.target.value, 'marginTop', element.id);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'marginTop', element.id);
            }}
          />
        </div>
      </div>
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Margin Bottom (px)</h3>
        <div className="form-control-item">
          <input
            type="number"
            className="form-control"
            placeholder=""
            min={0}
            value={element.options?.marginBottom ?? 24}
            onChange={(e) => {
              handlerChangeOption(e.target.value, 'marginBottom', element.id);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'marginBottom', element.id);
            }}
          />
        </div>
      </div>
      {/*<div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Duplicate Field</h3>
        <button className="btn btn-outline" onClick={() => duplicateElement(element.id)}>
          <i className="icon-copy mr-2"></i>Duplicate
        </button>
        <span className="text-secondary">Duplicate this field with all saved settings</span>
      </div>*/}
      <InitiatorCanEditSetting element={element} onChange={handlerChangeOption} />

      <AddToCopyGroupSetting
        elementID={element?.id}
        selected={element?.options?.[ADD_TO_COPY_GROUP_SETTING_KEY]}
        onChange={handlerChangeOption}
      />
    </div>
  );
};
